import { openMailto } from "@/utils/mailto";
import Hero from "../components/hero";
import { RegulatoryCompliancePage } from "@features/general";
import heroImage from "@assets/images/compliance-hero.svg";
import safeIcon from "@assets/icons/safeIcon.svg";

const heroData = {
  title: "Your Trusted, Fully Licensed Gas Services Provider in the UAE",
  description:
    "GAZ operates under strict regulatory standards set by Dubai Civil Defense, ESMA, the UAE Fire & Life Safety Code, and the Federal Tax Authority. Our certifications, licenses, and compliance framework ensure safe, reliable, and transparent operations for every customer and partner.",
  image: heroImage,
  footerText:
    "We provide safe, certified and efficient gas connections to the UAE, delivered and activated quickly by our licensed technicians.",
  footerButtonText: "Talk to Our Team",
  footerButtonOnclick: () =>
    openMailto({ subject: "Regulatory Compliance Inquiry" }),
  footerIcon: <img src={safeIcon} alt="" className="w-7 h-7" />,
};

function RegulatoryCompliance() {
  return <RegulatoryCompliancePage hero={<Hero data={heroData} />} />;
}

export default RegulatoryCompliance;
